module.exports = __webpack_public_path__ + "img/136fa33.jpg";